import { PropsUtil } from "./props-util";

export class TypologicUtil {
  propsUtil: PropsUtil;

  constructor(props: { [key: string]: any }) {
    this.propsUtil = new PropsUtil(props);
  }

  /*
    Restituisce la lista di id dei vocabolari da escludere
  */
  getExcludedVocabularyIds(): string[] {
    return this.propsUtil.getProp("excludedVocabularyIds");
  }

  /*
    Restituisce l'endpoint che recupera tutti i vocabolari
  */
  getVocabulariesEndpoint(): string {
    return this.propsUtil.getProp("vocabulariesEndpoint");
  }

  /*
  Restituisce la variabile che indica se recuperare l'id dell'obbligo in sessione
*/
  getResumeIdObbligo(): string {
    return this.propsUtil.getProp("resumeIdObbligo");
  }

  /*
    Restituisce l'endpoint che recupera tutte le categorie date un vocabolario (l'id viene concatenato)
  */
  getCategoriesEndpoint(): string {
    return this.propsUtil.getProp("categoriesEndpoint");
  }

  /*
    Restituisce l'endpoint che recupera tutte le categorie date un entity type (esempio: BILANCI)
    a cui può essere concatenato l'id del record (entity type)
  */
  getAssociableCategoriesEndpoint(): string {
    return this.propsUtil.getProp("associableCategoriesEndpoint");
  }

  /*
    Restituisce il nome della proprietà che identifica il vocabolario
  */
  getAttrVocabularyId(): string {
    return this.propsUtil.getProp("attrVocabularyId") || "id";
  }

  /*
    Restituisce il nome della proprietà che identifica il vocabolario
  */
  getAttrCategoryId(): string {
    return this.propsUtil.getProp("attrCategoryId") || "id";
  }

  getAttrLabel(): string {
    return this.propsUtil.getProp("attrLabel") || "description";
  }

  getAttrProp(): string {
    return this.propsUtil.getProp("attrProp") || "name";
  }

  getField(): any {
    return this.propsUtil.getProp("field");
  }

  getPropName(): any {
    return this.propsUtil.getProp("propName") || "categories";
  }

  getAction(): string {
    return this.propsUtil.getProp("action");
  }

  getFlatMapping(): boolean {
    return this.propsUtil.getProp("flatMapping") || true;
  }

  getReadOnly(): boolean {
    return this.propsUtil.getProp("readOnly") || false;
  }

  getAttrAssociable(): string {
    return "vocabularyId";
  }

  isConcatenable(): string {
    return this.propsUtil.getProp("concatenable") || false;
  }

}